const SET_SYSTEM_SETTINGS = (state, obj) => {
  state.systemSettings = {
    ...obj,
    logo: obj['logo']['url'],
    logoAuth: obj['logo_auth']['url']
  }
}

export default {
  SET_SYSTEM_SETTINGS
}



// WEBPACK FOOTER //
// ./src/features/auth/store/mutations.js